export default __webpack_public_path__ + "static/media/pdf.2f2d4845.svg";